import { Multiselect, Select } from '@amzn/awsui-components-react-v3';
import React from 'react';
import { Asterisk } from './asterisk';
import { SelectedTokenLimits } from '../const/dropdown_elements'
import {findOption} from "../reports/utils/buttons";

export class MarketplaceSelection extends React.Component {
  getSelected(selectedMarketplaceIds) {
    const { options } = this.props;
    if(this.props.multiselect) {
      return selectedMarketplaceIds && selectedMarketplaceIds.length
             ? selectedMarketplaceIds
               .split(',')
               .sort()
               .map((id) => options.find((m) => m.value === id))
             : [];
    } else {
      return selectedMarketplaceIds && selectedMarketplaceIds.split(',').length === 1
             ? selectedMarketplaceIds.split(',')[0] : '';
    }
  }

  render() {
    return (
      <div>
        <b> {this.props.text} </b>
        <Asterisk required={this.props.required}/>
        { this.props.multiselect && (
          <Multiselect
            options={ this.props.options }
            filteringType={'auto'}
            placeholder={ this.props.text }
            onChange={ this.props.onChange }
            selectedOptions={ this.getSelected(this.props.selected) }
            data-cy={ this.props['data-cy'] }
            tokenLimit={this.props.tokenLimit || SelectedTokenLimits.MARKETPLACE || SelectedTokenLimits.DEFAULT}
            disabled={this.props.disabled}
          />)
        }
        {!this.props.multiselect && (
          <Select
            options={this.props.options}
            onChange={this.props.onChange}
            placeholder={ this.props.text }
            filteringType={'auto'}
            selectedOption={findOption(this.props.options, this.getSelected(this.props.selected))}
            data-cy={this.props['data-cy']}
          />
        )}
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'marketplace-selection'
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/marketplace_selection.jsx